"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.freeze");

var _themeCurrency = require("@shopify/theme-currency");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

var _quantitySelector = _interopRequireDefault(require("./quantity-selector"));

var _productSwatches = _interopRequireDefault(require("./product-swatches"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  addToCart: '[js-product-form="addToCart"]',
  comparePrice: '[js-product-form="comparePrice"]',
  hiddenInputComparePrice: '[js-product-form="hiddenInputComparePrice"]',
  container: '[js-product-form="container"]',
  masterSelector: '[js-product-form="masterSelector"]',
  optionSelector: '[js-product-form="optionSelector"]',
  price: '[js-product-form="price"]',
  quantitySelector: '[js-quantity-selector="container"]',
  countdown: '[js-product-form="countdown"]',
  preorderDisablePurchase: 'data-preorder-disable-purchase',
  printOnDemandMessage: '[js-print-on-demand="message"]'
};
/**
 * Create a new product form object.
 */

var _default = function _default(config) {
  /**
   * Instance settings.
   */
  var settings = {
    enableHistoryState: config.enableHistoryState || false
  };
  /**
   * DOM node selectors.
   */

  var container = document.querySelector("[js-product-form=\"".concat(config.container, "\"]"));
  var nodeSelectors = {
    addToCart: container.querySelector(selectors.addToCart),
    comparePrice: container.querySelector(selectors.comparePrice),
    hiddenInputComparePrice: container.querySelector(selectors.hiddenInputComparePrice),
    masterSelector: container.querySelector(selectors.masterSelector),
    optionSelector: container.querySelectorAll(selectors.optionSelector),
    price: container.querySelector(selectors.price),
    quantitySelector: container.querySelector(selectors.quantitySelector),
    countdown: container.querySelector(selectors.countdown),
    printOnDemandMessage: container.querySelector(selectors.printOnDemandMessage)
  };
  /**
   * Global instances.
   */

  var productData = Object.freeze(JSON.parse(document.getElementById('product').innerHTML));
  var currentVariant = {};
  var countdownInterval;
  /**
   * Initialise component.
   */

  function init() {
    if (currentVariant) {
      currentVariant = getVariantFromOptions();
    }

    constructDefaultState();
    setListeners();
    setOptionSelectorEvents();
    initCountdown();
  }
  /**
   * Set change events on option selectors.
   */


  function setOptionSelectorEvents() {
    _toConsumableArray(nodeSelectors.optionSelector).forEach(function (element) {
      var type = element.getAttribute('type');

      if (type === 'radio' || type === 'checkbox') {
        (0, _utils.on)('click', element, function () {
          return onSelectChange();
        });
        return;
      }

      (0, _utils.on)('change', element, function () {
        return onSelectChange();
      });
    });
  }
  /**
   * Set listeners.
   */


  function setListeners() {
    Frame.EventBus.listen('Variant:change', function (response) {
      return updateAddToCartState(response);
    });
    Frame.EventBus.listen('Variant:priceChange', function (response) {
      return onPriceChange(response);
    });
  }
  /**
   * Get the currently selected options from product form.
   * Works with all form input elements.
   * @return {array} options - Values of currently selected variants.
   */


  function getCurrentOptions() {
    var currentOptions = [];

    _toConsumableArray(nodeSelectors.optionSelector).forEach(function (element) {
      var type = element.getAttribute('type');
      var currentOption = {};

      if (type === 'radio' || type === 'checkbox') {
        if (element.checked) {
          currentOption.value = element.value;
          currentOption.index = element.dataset.index;
          currentOptions.push(currentOption);
        }
      } else {
        currentOption.value = element.value;
        currentOption.index = element.dataset.index;
        currentOptions.push(currentOption);
      }
    });

    return currentOptions;
  }
  /**
   * Find variant based on selected values.
   * @return {object || undefined} found - Variant object from product.variants.
   */


  function getVariantFromOptions() {
    var selectedValues = getCurrentOptions();
    var variants = productData.variants;
    var found = false;
    variants.forEach(function (variant) {
      var satisfied = true;
      selectedValues.forEach(function (option) {
        if (satisfied) {
          satisfied = option.value === variant[option.index];
        }
      });

      if (satisfied) {
        found = variant;
      }
    });
    return found || null;
  }
  /**
   * Event handler for when a variant price changes.
   */


  function onPriceChange(response) {
    nodeSelectors.price.innerText = (0, _themeCurrency.formatMoney)(response.price, theme.moneyFormat);

    if (nodeSelectors.comparePrice) {
      nodeSelectors.comparePrice.innerText = (0, _themeCurrency.formatMoney)(response.compare_at_price, theme.moneyFormat);
    }
  }
  /**
   * Displays or hides the POD (Print on Demand) message based on the variant's feature.
   * @param {Object} variant - The variant object containing variant information.
   */


  function podDivVisibilty(variant) {
    var metafieldsFeatures = container.querySelector('#_hasPointOfDemand');
    var podFeature = getFeature(variant);
    var stringifiedPodfeature = JSON.stringify(podFeature);

    if (podFeature == null) {
      nodeSelectors.printOnDemandMessage.style.display = 'none';
      metafieldsFeatures.value = '';
    } else if (podFeature.is_pod) {
      nodeSelectors.printOnDemandMessage.style.display = 'inline-block';
      metafieldsFeatures.value = stringifiedPodfeature;
      nodeSelectors.printOnDemandMessage.innerHTML = "\n        <div class=\"product-form__pod-message-container\">\n          <svg class=\"icon icon__print-point-on-demand\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 19 18\">\n            <mask id=\"a\" width=\"19\" height=\"18\" x=\"0\" y=\"0\" fill=\"#000\" maskUnits=\"userSpaceOnUse\">\n              <path fill=\"#fff\" d=\"M0 0h19v18H0z\"/>\n              <path fill-rule=\"evenodd\" d=\"M4.611 4.564H1.879c-.48 0-.879.384-.879.857v7.39c0 .473.399.857.88.857H4.61v3.047c0 .157.129.285.293.285h9.198a.288.288 0 0 0 .293-.285v-3.047h2.726c.486 0 .879-.384.879-.857v-7.39a.868.868 0 0 0-.88-.857h-2.725V1.286A.288.288 0 0 0 14.102 1H4.904a.288.288 0 0 0-.293.286v3.278Zm9.198 5.772v6.093H5.197v-6.093h8.612ZM6.72 15.279h5.563a.288.288 0 0 0 .294-.285.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .158.13.285.293.285Zm0-1.611h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.285H6.72a.288.288 0 0 0-.293.285c0 .158.13.286.293.286Zm7.674-.571h2.726a.288.288 0 0 0 .293-.286v-7.39a.288.288 0 0 0-.293-.286H1.879a.292.292 0 0 0-.293.286v7.39c0 .158.135.286.293.286h2.732V10.05c0-.158.129-.285.293-.285h9.198c.164 0 .293.127.293.285v3.047Zm-7.674-1.04h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .157.13.285.293.285Zm7.088-7.493V1.571H5.197v2.993h8.612Z\" clip-rule=\"evenodd\"/>\n            </mask>\n            <path fill=\"#000\" fill-rule=\"evenodd\" d=\"M4.611 4.564H1.879c-.48 0-.879.384-.879.857v7.39c0 .473.399.857.88.857H4.61v3.047c0 .157.129.285.293.285h9.198a.288.288 0 0 0 .293-.285v-3.047h2.726c.486 0 .879-.384.879-.857v-7.39a.868.868 0 0 0-.88-.857h-2.725V1.286A.288.288 0 0 0 14.102 1H4.904a.288.288 0 0 0-.293.286v3.278Zm9.198 5.772v6.093H5.197v-6.093h8.612ZM6.72 15.279h5.563a.288.288 0 0 0 .294-.285.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .158.13.285.293.285Zm0-1.611h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.285H6.72a.288.288 0 0 0-.293.285c0 .158.13.286.293.286Zm7.674-.571h2.726a.288.288 0 0 0 .293-.286v-7.39a.288.288 0 0 0-.293-.286H1.879a.292.292 0 0 0-.293.286v7.39c0 .158.135.286.293.286h2.732V10.05c0-.158.129-.285.293-.285h9.198c.164 0 .293.127.293.285v3.047Zm-7.674-1.04h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .157.13.285.293.285Zm7.088-7.493V1.571H5.197v2.993h8.612Z\" clip-rule=\"evenodd\"/>\n            <path fill=\"#000\" d=\"M4.611 4.564v.15h.15v-.15h-.15Zm0 9.104h.15v-.15h-.15v.15Zm9.784 0v-.15h-.15v.15h.15Zm0-9.104h-.15v.15h.15v-.15Zm-.586 5.772h.15v-.15h-.15v.15Zm0 6.093v.15h.15v-.15h-.15Zm-8.612 0h-.15v.15h.15v-.15Zm0-6.093v-.15h-.15v.15h.15Zm9.198 2.76h-.15v.15h.15v-.15Zm-9.784 0v.15h.15v-.15h-.15Zm9.198-8.532v.15h.15v-.15h-.15Zm0-2.993h.15v-.15h-.15v.15Zm-8.612 0v-.15h-.15v.15h.15Zm0 2.993h-.15v.15h.15v-.15Zm-.586-.15H1.879v.3h2.732v-.3Zm-2.732 0C1.32 4.414.85 4.861.85 5.421h.3c0-.386.327-.707.73-.707v-.3ZM.85 5.421v7.39h.3v-7.39h-.3Zm0 7.39c0 .56.47 1.007 1.03 1.007v-.3a.722.722 0 0 1-.73-.707h-.3Zm1.03 1.007H4.61v-.3H1.879v.3Zm2.581-.15v3.047h.3v-3.047h-.3Zm0 3.047c0 .243.199.435.443.435v-.3a.138.138 0 0 1-.143-.136h-.3Zm.443.435h9.198v-.3H4.904v.3Zm9.198 0a.438.438 0 0 0 .443-.435h-.3a.138.138 0 0 1-.143.135v.3Zm.443-.435v-3.047h-.3v3.047h.3Zm-.15-2.897h2.726v-.3h-2.726v.3Zm2.726 0c.566 0 1.029-.447 1.029-1.007h-.3a.718.718 0 0 1-.73.707v.3Zm1.029-1.007v-7.39h-.3v7.39h.3Zm0-7.39c0-.56-.463-1.007-1.03-1.007v.3c.408 0 .73.32.73.707h.3Zm-1.03-1.007h-2.725v.3h2.726v-.3Zm-2.575.15V1.286h-.3v3.278h.3Zm0-3.278c0-.244-.2-.436-.443-.436v.3c.084 0 .143.064.143.136h.3ZM14.102.85H4.904v.3h9.198v-.3Zm-9.198 0a.438.438 0 0 0-.443.436h.3c0-.072.059-.136.143-.136v-.3Zm-.443.436v3.278h.3V1.286h-.3Zm9.198 9.05v6.093h.3v-6.093h-.3Zm.15 5.943H5.197v.3h8.612v-.3Zm-8.462.15v-6.093h-.3v6.093h.3Zm-.15-5.943h8.612v-.3H5.197v.3Zm1.524 4.943h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.435h-.3a.138.138 0 0 1-.144.135v.3Zm.444-.435c0-.243-.2-.436-.444-.436v.3c.085 0 .144.064.144.136h.3Zm-.444-.436H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.436h.3c0-.072.06-.136.143-.136v-.3Zm-.443.436c0 .243.2.435.443.435v-.3a.138.138 0 0 1-.143-.135h-.3Zm.443-1.176h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.436h-.3a.138.138 0 0 1-.144.136v.3Zm.444-.436c0-.243-.2-.435-.444-.435v.3c.085 0 .144.063.144.135h.3Zm-.444-.435H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.435h.3c0-.072.06-.135.143-.135v-.3Zm-.443.435c0 .244.2.436.443.436v-.3a.138.138 0 0 1-.143-.136h-.3Zm8.117-.135h2.726v-.3h-2.726v.3Zm2.726 0a.438.438 0 0 0 .443-.436h-.3a.138.138 0 0 1-.143.136v.3Zm.443-.436v-7.39h-.3v7.39h.3Zm0-7.39c0-.244-.2-.436-.443-.436v.3c.084 0 .143.064.143.136h.3Zm-.443-.436H1.879v.3h15.242v-.3Zm-15.242 0a.442.442 0 0 0-.443.436h.3c0-.07.063-.136.143-.136v-.3Zm-.443.436v7.39h.3v-7.39h-.3Zm0 7.39c0 .245.207.436.443.436v-.3a.142.142 0 0 1-.143-.136h-.3Zm.443.436h2.732v-.3H1.879v.3Zm2.882-.15V10.05h-.3v3.047h.3Zm0-3.047c0-.072.059-.135.143-.135v-.3a.438.438 0 0 0-.443.435h.3Zm.143-.135h9.198v-.3H4.904v.3Zm9.198 0c.084 0 .143.063.143.135h.3c0-.244-.2-.435-.443-.435v.3Zm.143.135v3.047h.3V10.05h-.3ZM6.72 12.206h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.435h-.3a.138.138 0 0 1-.144.135v.3Zm.444-.435c0-.244-.2-.436-.444-.436v.3c.085 0 .144.064.144.136h.3Zm-.444-.436H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.436h.3c0-.072.06-.136.143-.136v-.3Zm-.443.436c0 .243.2.435.443.435v-.3a.138.138 0 0 1-.143-.135h-.3Zm7.68-7.207V1.571h-.3v2.993h.3Zm-.15-3.143h-8.61v.3h8.61v-.3Zm-8.76.15v2.993h.3V1.571h-.3Zm.15 3.143h8.61v-.3h-8.61v.3Z\" mask=\"url(#a)\"/>\n          </svg>\n\n          <span>".concat(theme.strings.printOnDemand, "</span>\n        </div>\n      ");
    } else {
      nodeSelectors.printOnDemandMessage.style.display = 'none';
      metafieldsFeatures.value = '';
    }
  }
  /**
   * Retrieves the feature of the given variant.
   * @param {Object} variant - The variant object containing variant information.
   * @returns {Object|null} - The parsed feature object if found, otherwise null.
   */


  function getFeature(variant) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = nodeSelectors.optionSelector[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var element = _step.value;
        var feature = element.getAttribute('data-feature');

        try {
          var parsedFeature = JSON.parse(feature);
          var currentVariantId = element.getAttribute('data-variant-id');

          if (currentVariantId == variant.id) {
            if (parsedFeature == null) {
              return null;
            } else {
              return parsedFeature;
            }
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return null;
  }
  /**
   * Event handler for when a variant input changes.
   */


  function onSelectChange() {
    var variant = getVariantFromOptions();
    Frame.EventBus.emit('Variant:change', variant);

    if (!variant) {
      return;
    }

    podDivVisibilty(variant);
    updateMasterSelect(variant); // updatePrice(variant);

    currentVariant = variant;

    if (settings.enableHistoryState) {
      updateHistoryState(variant);
    } // Update hidden input value which is passed as a property for compare at price. 


    nodeSelectors.hiddenInputComparePrice.value = variant.compare_at_price;
  }
  /**
   * Updates the DOM state of the add to cart button.
   * @param {boolean} enabled - Decides whether cart is enabled or disabled.
   * @param {string} text - Updates the text notification content of the cart.
   */


  function updateAddToCartState(variant) {
    if (variant) {
      enableAddToCart();
    } else {
      disableAddToCart();
      nodeSelectors.addToCart.innerText = theme.strings.unavailable;
      return;
    }

    if (variant.available) {
      var countdownPreorderDate = new Date(nodeSelectors.addToCart.getAttribute('data-preorder') * 1000);
      var countdownComingSoonDate = new Date(nodeSelectors.addToCart.getAttribute('data-comingsoon') * 1000);
      var countdownBundleSoonDate = new Date(nodeSelectors.addToCart.getAttribute('data-bundlesoon') * 1000);

      if ((variant.name.toLowerCase().indexOf('paperback') !== -1 || variant.name.toLowerCase().indexOf('hardback') !== -1) && variant.name.toLowerCase().indexOf('bundle') === -1) {
        if (nodeSelectors.addToCart.getAttribute('data-preorder')) {
          disableAddToCart();
          updateCountdown(countdownPreorderDate);
          nodeSelectors.addToCart.innerText = theme.strings.comingSoon;

          if (nodeSelectors.countdown) {
            nodeSelectors.countdown.classList.remove(_cssClasses["default"].disabled);
          }
        } else {
          enableAddToCart();
          nodeSelectors.addToCart.innerText = theme.strings.addToCart;

          if (nodeSelectors.countdown) {
            nodeSelectors.countdown.classList.add(_cssClasses["default"].disabled);
            stopCountdown();
          }
        }
      } else if (variant.name.toLowerCase().indexOf('ebook') !== -1 && variant.name.toLowerCase().indexOf('paperback') === -1 && variant.name.toLowerCase().indexOf('hardback') === -1) {
        if (nodeSelectors.addToCart.getAttribute('data-comingsoon')) {
          disableAddToCart();
          updateCountdown(countdownComingSoonDate);
          nodeSelectors.addToCart.innerText = theme.strings.comingSoon;

          if (nodeSelectors.countdown) {
            nodeSelectors.countdown.classList.remove(_cssClasses["default"].disabled);
          }
        } else {
          enableAddToCart();
          nodeSelectors.addToCart.innerText = theme.strings.addToCart;

          if (nodeSelectors.countdown) {
            nodeSelectors.countdown.classList.add(_cssClasses["default"].disabled);
            stopCountdown();
          }
        }
      } else if (variant.name.toLowerCase().indexOf('bundle') !== -1) {
        if (nodeSelectors.addToCart.getAttribute('data-bundlesoon')) {
          disableAddToCart();
          updateCountdown(countdownBundleSoonDate);
          nodeSelectors.addToCart.innerText = theme.strings.comingSoon;

          if (nodeSelectors.countdown) {
            nodeSelectors.countdown.classList.remove(_cssClasses["default"].disabled);
          }
        } else {
          enableAddToCart();
          nodeSelectors.addToCart.innerText = theme.strings.addToCart;

          if (nodeSelectors.countdown) {
            nodeSelectors.countdown.classList.add(_cssClasses["default"].disabled);
            stopCountdown();
          }
        }
      } else {
        nodeSelectors.addToCart.innerText = theme.strings.addToCart;

        if (nodeSelectors.countdown) {
          nodeSelectors.countdown.classList.add(_cssClasses["default"].disabled);
        }
      }
    } else {
      disableAddToCart();
      nodeSelectors.addToCart.innerText = theme.strings.soldOut;
    }
  }

  function initCountdown() {
    var countdownPreorder = nodeSelectors.addToCart.getAttribute('data-preorder'),
        countdownPreorderDate;

    if (countdownPreorder) {
      countdownPreorderDate = new Date(countdownPreorder * 1000);
      updateCountdown(countdownPreorderDate);
    }
  }

  function updateCountdown(referenceDate) {
    clearInterval(countdownInterval);
    startCountdown(referenceDate);
    countdownInterval = setInterval(function () {
      startCountdown(referenceDate);
    }, 1000);
  }

  function startCountdown(referenceDate) {
    var countdownText;
    var currentDate = new Date().getTime();
    var distance = referenceDate - currentDate;
    var daysLeft = Math.floor(distance / (1000 * 60 * 60 * 24));

    if (daysLeft === 1) {
      countdownText = theme.strings.countdownTextOne.replace('[days]', daysLeft);
    } else if (daysLeft === 0) {
      countdownText = theme.strings.countdownTextOne.replace('[days]', '1');
    } else {
      countdownText = theme.strings.countdownTextMany.replace('[days]', daysLeft);
    }

    nodeSelectors.countdown.innerText = countdownText;
    nodeSelectors.countdown.classList.remove(_cssClasses["default"].disabled); // If the count down is finished, write some text

    if (distance < 0) {
      clearInterval(countdownInterval);
      nodeSelectors.addToCart.innerText = theme.strings.addToCart;
      nodeSelectors.countdown.classList.add(_cssClasses["default"].disabled);
    }
  }

  function stopCountdown() {
    clearInterval(countdownInterval);
  }
  /**
   * Trigger event when variant price changes.
   * @param {object} variant - Currently selected variant.
   */


  function updatePrice(variant) {
    Frame.EventBus.emit('Variant:priceChange', variant);
  }
  /**
   * Update hidden master select of variant change.
   * @param {object} variant - Currently selected variant.
   */


  function updateMasterSelect(variant) {
    nodeSelectors.masterSelector.value = variant.id;
  }
  /**
   * Update history state for product deeplinking.
   * @param {object} variant - Currently selected variant.
   */


  function updateHistoryState(variant) {
    if (!window.history.replaceState || !variant) {
      return;
    }

    var newurl = "\n      ".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(variant.id, "\n    ");
    window.history.replaceState({
      path: newurl
    }, '', newurl);
  }
  /**
   * Construct Quantity Selector component.
   */


  function constructQuantitySelectors() {
    new _quantitySelector["default"](nodeSelectors.quantitySelector.id).init();
  }
  /**
   * Construct product swatches.
   */


  function constructProductSwatches() {
    if (!theme.features.enableSwatches) {
      return;
    }

    (0, _productSwatches["default"])().init();
  }
  /**
   * Add disable state to add to cart button.
   */


  function disableAddToCart() {
    nodeSelectors.addToCart.setAttribute('disabled', true);
    nodeSelectors.addToCart.classList.add(_cssClasses["default"].disabled);
  }
  /**
   * Set add to cart button to active.
   */


  function enableAddToCart() {
    nodeSelectors.addToCart.removeAttribute('disabled');
    nodeSelectors.addToCart.classList.remove(_cssClasses["default"].disabled);
  }
  /**
   * Construct default state.
   */


  function constructDefaultState() {
    constructProductSwatches();
    constructQuantitySelectors();
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init,
    getVariantFromOptions: getVariantFromOptions
  });
};

exports["default"] = _default;